import React from 'react';
import HeaderSettings from '../components/HeaderSettings';

const Header = () => {
  return <HeaderSettings />;
};

export default Header; 